import "bootstrap/dist/css/bootstrap.min.css";
import Navigation from "./Components/NavigationComponent/Navigation";
import TopNavigation from "./Components/NavigationComponent/TopNavigation";

function HelpPage() {
    return <>
        <Navigation />
        <TopNavigation />
        <div className="page-container" style={{ padding: "15px" }}>
            <h1 class="display-5">Help</h1>
            <h1 class="display-6">FAQs</h1>
            <p>Q. How to add configs?</p>
            <p>Ans. Config key value pairs can be created. For eg: DeviceCrtStorageOption says where the device certificate has to be stored.</p><br />
            <p>Q. How to register a Parnter in Management Server?</p>
            <p>Ans. The partner's contact details and the CA, Sub CA and partner certificate needs to be uploaded to register a partner.</p><br />
            <p>Q. How devices are validated?</p>
            <p>Ans. Management server has a white listed devices marked. When the client sends the request for the registration, server validates against the white listed devices list and when found, it registers the devices. It ensures that the device is from the genuine vendor.
            </p>
        </div>
    </>


}

export default HelpPage;